module.exports = __webpack_public_path__ + "img/3-sdg-border@2x.dda5aa6a.png";